import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { UserEntity } from '@interpals/api-web';

import api from 'api';
import { ReduxState } from 'redux/root-reducer';

export const setViewedLastFetched = createAction<number>('set/viewed-last-fetched');
export const clearViewedUsers = createAction('clear/viewed');

export const getViewedUsers = createAsyncThunk<UserEntity[] | undefined, void, { state: ReduxState }>(
    'get/viewed',
    async (_, { getState, dispatch }) => {
        const id = getState().account.data?.id;

        if (id) {
            dispatch(setViewedLastFetched(new Date().getTime()));

            return api.getRecentlyViewedUsers({ id }).then((response) => response.data);
        }
    },
);
